export default {
  methods: {
    isEmpty(value) {
      if (Array.isArray(value) || typeof value === 'string') {
        return value.length === 0
      }

      if (value === '' || value === undefined || value == null) {
        return true
      }

      if (typeof value === 'object') {
        return Object.keys(value).length === 0
      }

      throw new Error('Unable to handle value: ', value)
    }
  }
}
